export const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : window.location.protocol + "//" + window.location.host;

export const aboutBaseUrl = baseUrl + "/api/v1/about/file/";

export const productionBaseUrl = baseUrl + "/api/v1/productions/file/";
export const productionVideoUrl = baseUrl + "/api/v1/productions/video/";